import { cn } from '~/lib/cn';
import { variants } from '~/lib/variants';

export const chevron = variants({
  base: [cn('absolute right-sm mx-sm transition-transform')],
  variants: {
    state: {
      default: [cn('rotate-0 transform')],
      open: [cn('rotate-180 transform')],
    },
  },
});
